import { brandI, brandListI } from 'interfaces';
import { get, patch, post, remove } from "services/services.methods";
import { BrandsPaths } from 'services/services.paths';

export const getBrands = async () => {
  const response = await get<brandListI[]>(BrandsPaths.get);

  return response.data;
};

export const removeBrand = async (id: number) => {
  const response = await remove<any>(BrandsPaths.delete + `/${id}`);

  return response;
};

export const createBrand = async (brand: brandI) => {
  const response = await post<any>(BrandsPaths.post, brand);

  return response;
};

export const updateBrand = async (Brand: brandI, BrandId: string) => {
  const response = await patch<any>(BrandsPaths.put + `/${BrandId}`, Brand);

  return response;
};